import { Component, OnInit } from '@angular/core';

import { OptionProperty } from '../../types/control.types';
import { OptionsControlBaseComponent } from '../../controls/options-control-base/options-control-base.component';
import { AbstractPropertyEditorBase } from '../../types/property-editor.types';
import { OptionItem } from '../../types/control.types';

@Component({
  selector: 'df-option-property-editor',
  templateUrl: './option-property-editor.component.html',
  styleUrls: ['./option-property-editor.component.css']
})
export class OptionPropertyEditorComponent extends AbstractPropertyEditorBase implements OnInit {
  tabsData: Array<OptionProperty>;
  choice?: number = 0;

  set tabValue(val: any) {
    this._tabValue = val;
    this.memberSetting.disabled = !this._tabValue;
  }
  get tabValue(): any {
    return this._tabValue;
  }

  memberSetting = { maxlength: 50, reg: /^[A-Za-z]+[A-Za-z0-9]*$/, disabled: true };

  displayMember: string;
  valueMember: string;

  control: OptionsControlBaseComponent<OptionItem>;

  private _tabValue: string;

  constructor() {
    super();
  }

  ngOnInit() {}

  get showSetMember(): boolean {
    return this.choice === 1;
  }

  selectedItem(event: any) {
    this.tabsData.forEach((item: OptionProperty, index) => {
      if (event.id === item.id) {
        item.selected = true;
        this.choice = index;
        this.tabValue = item.value;
        this.displayMember = item.displayMember;
        this.valueMember = item.valueMember;
      } else {
        item.selected = false;
      }
    });
  }

  afterControlValueInit() {
    this.tabsData = this.value;
    this.defaultSelection();
  }

  defaultSelection() {
    if (!this.tabsData) {
      this.tabsData = [
        { text: 'èªå®ä¹', id: 'custom', selected: true, value: 'éé¡¹1\néé¡¹2\néé¡¹3' },
        { text: 'æ°æ®æº', id: 'dataSource', selected: false, value: '' }
      ];
    }
    this.selectedItem(this.tabsData.filter((s: OptionProperty) => s.selected === true)[0]);
    this.setTabValue();
  }

  setTabValue() {
    // è®¾ç½®æ°æ®
    this.tabsData[this.choice].value = this.tabValue;
    this.tabsData[this.choice].displayMember = this.displayMember;
    this.tabsData[this.choice].valueMember = this.valueMember;
    this.afterSetControlValue(this.tabsData);
    this.control.optionValueChange();
  }
}
